import { createFileRoute, redirect } from '@tanstack/react-router'
import { DEFAULT_LOCALE, isValidLocale, withLocalePath } from '@/lib/i18n-utils'

// Self-service sign-up is closed: accounts are issued by Horizon Tech. The route
// stays so old links land on sign-in instead of a 404.
export const Route = createFileRoute('/{-$locale}/register')({
  ssr: false,
  beforeLoad: ({ params }) => {
    const locale = isValidLocale(params.locale) ? params.locale : DEFAULT_LOCALE
    throw redirect({ to: withLocalePath('/login', locale) })
  },
})
